<template>
  <div>
    <div class="message flex flex-row" :class="{'unread-message': !message.moderatedAt}" @mousemove="markAsRead">
      <img v-if="message.user.avatar"
           :src="message.user.avatar"
           :alt="message.user.fullname" class="avatar">
      <img v-else
           :src="getDefaultAvatar(message.user.fullname)"
           :alt="message.user.fullname" class="avatar">
      <div class="message-wrapper">
        <p class="message-header">
          <span class="username font-600">{{ message.user.fullname }}</span>
          <span class="sent-date font-300">{{ formattedDate }}</span>
          <a href="#" class="ml-3 text-green-600" @click.prevent="showReplyForm=true">Ответить</a>
          <a href="#" class="ml-3 text-red-600" @click.prevent="removeMessage">Удалить</a>
        </p>
        <p class="message-content font-300">{{ message.text }}</p>
        <div class="reply-form" v-if="showReplyForm">
          <form class="flex flex-row flex-space-between" @submit.prevent="sendReplyMessage">
            <input type="text" name="text" class="flex flex-1" v-model="replyMessage">
            <button class="ml-2 text-green-600" type="button" @click.prevent="sendReplyMessage">Ответить</button>
            <button class="ml-2 text-yellow-600" type="button" @click.prevent="closeReplyForm">Отмена</button>
          </form>
        </div>
      </div>
    </div>
    <div class="pl-8" v-if="message.replies && message.replies.data ">
      <template v-for="childMessage in message.replies.data" :key="childMessage.id">
        <node-chat-message :message="childMessage" />
      </template>
    </div>
  </div>

</template>

<script>
import {DateTime} from "luxon";
import {feathersClient, messagesTypeService} from "../../feathers-client";

export default {
  name: "NodeChatMessage",
  props: [
      'message'
  ],
  data: () => ({
    showReplyForm: false,
    replyMessage: '',
  }),
  methods: {
    getDefaultAvatar(username){
      const letter = username
        ? Array.from(username.toUpperCase())[0]
        : 'U'
      return `https://dummyimage.com/45x45/c4bcc4/fff.png&text=${letter}`;
    },
    removeMessage(){
      if(!confirm("Действительно удалить сообщение?")) return
      feathersClient.service(`messages/${this.message.type}/${this.message.typeId}`).remove(this.message.id);
    },
    sendReplyMessage(){
      feathersClient.service(`messages/${this.message.type}/${this.message.typeId}`)
          .create({
            replyMessageId: this.message.id,
            text: this.replyMessage
          })
          .then(() => {
            this.closeReplyForm()
          })
    },
    closeReplyForm(){
      this.replyMessage = ''
      this.showReplyForm = false
    },
    markAsRead(){
      if(this.message.moderatedAt) return
      this.message.moderatedAt = new Date()
      feathersClient.service(`messages`)
          .patch(null, {
                moderatedAt: new Date()
              }, { query: {id: {$in: [this.message.id]}} });

    }
  },
  computed: {
    formattedDate() {
      return DateTime.fromISO(this.message.createdAt, {
        setZone: Nova.config('userTimezone') || Nova.config('timezone'),
      }).toLocaleString({
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      })
    }
  }
}
</script>

<style scoped>

</style>
